import React from 'react'

function Client() {
  return (
    <div>Client</div>
  )
}

export default Client